import { ThemeOptions } from "@mui/material"
import { CustomColors } from "../../theme/theme"

const ThemeGenerator = (mode: "dark" | "light"): ThemeOptions => {
  return {
    palette: {
      primary: {
        main: "#1B920A",
      },
      secondary: {
        main: "#58CA04",
      },
      background: {
        default: "#1C2218",
        paper: "#1C2218",
      },

      mode: "dark",
    },
    typography: {
      fontFamily: "Inter",
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: CustomColors?.adminAppOutlineColor,
          },
        },
      },
      MuiSelect: {
        defaultProps: {
          MenuProps: {
            MenuListProps: {
              sx: {
                "& .MuiMenuItem-root": {
                  color: "#fff",
                },
              },
            },
          },
        },
      },
    },
  }
}

export default ThemeGenerator
